module.exports = __webpack_public_path__ + "static/media/millionaire-aisle.586de0f3.png";